export const OrgStatus = {
  Active: 'active',
  Suspended: 'suspended',
  Inactive: 'inactive',
} as const;

export type OrgStatus = (typeof OrgStatus)[keyof typeof OrgStatus];
